// Mod groups selectable by magic copy key, deduped across the locations in the current context.
app.ModGroupOption = app.AbstractModel.extend({
  ModelName: 'modGroupOption',

  displayName() {
    return `${this.get('name')} (${this.id})`;
  },
});

app.ModGroupOptionList = app.AbstractCollection.extend({
  model: app.ModGroupOption,

  parse(data) {
    return data.data.modGroupOptions.map((option) => {
      return {
        _id: option.magicCopyKey,
        name: option.name,
      };
    });
  },

  url() {
    return '/api/v2/settings/mod-group-options';
  },
});
